import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
  HostListener,
} from '@angular/core';
import { MessageService } from 'primeng';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { InboxJobsService } from '../../services/inbox-jobs.service';
import { JobsContactService } from '../../services/job-contact.service';
import { MapService } from '../../services/map.service';
import { SupplierService } from '../../services/supplier.service';
import { InputHelper } from '../../utils/input.helper';

import { JobsDeploymentService } from '../../services/job-deployment.service';
import { MapControl } from '../map-control/map-control.component';

@Component({
  selector: 'driver-plan',
  styleUrls: ['./driver-plan.component.scss'],
  templateUrl: './driver-plan.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class DriverPlanComponent implements OnInit {
  @ViewChild('driverPlanMap') driverPlanMap: MapControl;
  // Binding properties
  @Input('supplierId')
  public set supplierId(value: number) {
    this._supplierId = value;
  }
  public get supplierId() {
    return this._supplierId;
  }
  private _supplierId: number;

  @Input('scheduledDate')
  public set scheduledDate(value: any) {
    this._scheduledDate = value;
  }
  public get scheduledDate() {
    return this._scheduledDate;
  }
  private _scheduledDate: any;

  @Input('tasks')
  public set tasks(value: any[]) {
    this._tasks = value;
  }
  public get tasks() {
    return this._tasks;
  }
  private _tasks: any[];

  public driverPlanJobs: any[] = [];
  public driverPlanTasks: any[] = [];
  public supplierHouse: any[] = [];
  public supplier: any;
  public isLoading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    private jobDeploymentService: JobsDeploymentService,
    public inboxjobsService: InboxJobsService,
    public mapService: MapService,
    private contactService: JobsContactService,
    private supplierService: SupplierService,
  ) {}

  ngOnInit() {}

  public load() {
    this.driverPlanJobs = [];
    this.driverPlanTasks = [];

    var request = {
      supplierId: this.supplierId,
      scheduledDate: this.scheduledDate,
    };

    this.isLoading = true;
    this.jobDeploymentService
      .getDriverPlan(request)
      .then((res) => {
        this.supplier = res.supplier;
        this.supplierHouse = [res.supplier];

        res.jobs.forEach((job) => {
          let jobTask = { id: job.id, jobNumber: job.jobNumber, tasks: [] };
          job.orders.forEach((order) => {
            order.tasks.forEach((task) => {
              this.driverPlanTasks.push(task);
              jobTask.tasks.push(task);
            });
          });

          this.driverPlanJobs = this.driverPlanJobs.concat(jobTask);
        });

        this.isLoading = false;
        this.driverPlanMap.autofitObjects();
      })
      .catch((error) => {
        this.isLoading = false;
      });
  }
}
